module.exports = __webpack_public_path__ + "img/icon-96x96.b86774ed.png";